<template>
    <div class="cate_count">
        <div class="cate_count_header">
            <div class="left_header_left">
                <img class="header_left_icon" src="@/assets/img/big_data/patentee.png">
                <div class="header-title">专利权人</div>
            </div>
            <div class="left_header_right">CLASSIFICATION STATISTICS</div>
            <div class="bordline"></div>
        </div>
        <div id="cate_count_pieChart" style="width: 357px;height: 786px;">
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    name: 'CateCount',
    props:{
        cateCountData:{
            type: Object,
			default: () => { }
        }
    },
    mounted() {
        const chartContainer = document.getElementById('cate_count_pieChart');
        const chart = echarts.init(chartContainer);
        var charts = { // 按顺序排列从大到小
            cityList: this.cateCountData.name,
            cityData: this.cateCountData.value
        }
        var top10CityList = charts.cityList
        var top10CityData = charts.cityData
        let lineY = []
        for (var i = 0; i < charts.cityList.length; i++) {
            var data = {
                name: charts.cityList[i],
                value: top10CityData[i],
                itemStyle: {
                    normal: {
                        show: true,
                        color: this.cateCountData.color,
                        barBorderRadius: 4
                    },
                }
            }
            lineY.push(data)
        }
        console.log(lineY)
        const options = {
            title: {
                show: false
            },
            tooltip: {
                trigger: 'item'
            },
            grid: {
                borderWidth: 0,
                top: '0%',
                left: '5%',
                right: '15%',
                bottom: '3%'
            },
            yAxis: [{
                type: 'category',
                inverse: true,
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    show: false,
                    inside: false
                },
                data: top10CityList
            }, {
                type: 'category',
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    show: true,
                    inside: false,
                    textStyle: {
                        color: '#FFFFFF',
                        fontSize: '13',
                        fontWeight: 'bold',
                    },
                    formatter: function (val) {
                        return `${val}`
                    }
                },
                splitArea: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                data: top10CityData.reverse()
            }],
            xAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    show: false
                }
            },
            series: [{
                name: '',
                type: 'bar',
                zlevel: 2,
                barWidth: '24px',
                data: lineY,
                animationDuration: 1500,
                label: {

                    normal: {
                        color: '#FFFFFF',
                        show: true,
                        position: [10, 8],
                        textStyle: {
                            fontSize: 13,
                            fontWeight: 'bold',
                        },
                        formatter: function (a, b) {
                            return a.name
                        }
                    }
                }
            }],
            animationEasing: 'cubicOut'
        }

        chart.setOption(options);
        chart.on('click',function(params){
          let name = params.data.name
          localStorage.setItem('consolePatentee', name)
          window.open('#/patent/monitor','_blank')
        })
    }
}
</script>
<style lang="stylus" scoped>
.cate_count{
    width: 411px;
    height: 855px;
    border-radius: 10px;
    border: 1px solid rgba(221, 252, 255, 0.2);
    background-color:rgba(221, 252, 255, 0.1);
    position: relative;
    #cate_count_pieChart{
        margin-left:27px
    }
   .cate_count_header{
        display:flex;
        height:56px;
        align-items:center;
        justify-content:space-between;
        margin-left:27px;
        margin-right:29px;
        position: relative
        .bordline{
            width:100%;
            height:1px;
            background:linear-gradient(to right,rgba(0,0,0,0)0%,#9BC1FF 50%,rgba(0,0,0,0)100%);
            position:absolute;
            bottom:0
        }

   }
    .left_header_right{
        color: #B7D2FF;
        font-size: 12px;
        font-weight: 500;
        opacity: 0.2;
    }
    .left_header_left{
       
        display:flex;
        height:56px;
        align-items:center
        .header-title{
            font-size: 21px;
            font-family: 'Alimama ShuHeiTi';
            font-weight: bold;
            color: #9BC1FF;
        }
        .header_left_icon{
            width:23px;
            height:21px;
            margin-right:15px
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/console/components/cateCount.vue